const _temp0 = require("../../../images/profile-ava.png");
const _temp1 = require("../../../images/profile-lior.png");
const _temp2 = require("../../../images/profile-mup.png");
const _temp3 = require("../../../images/profile-ramen-bot.png");
const _temp4 = require("../../../images/profile-rb.png");
const _temp5 = require("../../../images/profile-zeke.png");
module.exports = {
  "ava": _temp0,
  "lior": _temp1,
  "mup": _temp2,
  "ramen-bot": _temp3,
  "rb": _temp4,
  "zeke": _temp5
}